import { FC } from 'react'

import { AppDialog } from '@/components/AppDialog'
import { Divider } from '@/components/Divider'
import UniteIcon from '@/components/icons/pkg-unite.svg?react'
import { Button } from '@/components/ui/button'

interface UniteConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading?: boolean
}

export const UniteConfirmationDialog: FC<UniteConfirmationDialogProps> = ({ isOpen, onClose, onConfirm, isLoading = false }) => {
  return (
    <AppDialog isOpen={isOpen} onOpenChange={onClose} hideCloseButton className='!max-w-md'>
      <div className='flex flex-col items-center gap-6'>
        {/* Icon and Title */}
        <div className='flex flex-col items-center gap-4'>
          <div className='h-6 w-6'>
            <UniteIcon className='text-icon-primary h-full w-full' />
          </div>
          <h2 className='text-text-primary text-center text-lg font-medium'>איחוד חבילות- חיסכון חכם!</h2>
        </div>

        {/* Description */}
        <div className='flex flex-col items-center gap-6'>
          <div className='text-text-secondary text-center text-sm leading-5'>
            <p className='mb-1'>אנחנו נאחד עבורכם חבילות וכך תוכל לחסוך דמי משלוח.</p>
            <p className='mb-1'>רק שימו לב! גובה המיסוי משתנה</p>
            <p className='mb-1'>בהתאם לסך כל המוצרים בחבילה המאוחדת.</p>
            <p>חבילות מעל 75$ עלולות להיות מחויבות במס</p>
          </div>

          {/* Cost Info */}
          <div className='bg-button-primary-selected-segment text-text-secondary rounded-full px-3 py-2'>
            <p className='text-center text-xs'>השירות כרוך בתשלום של $1.5 לכל חבילה ויחושב בחשבון הסופי</p>
          </div>
        </div>
        <Divider />
        {/* Action Button */}
        <div className='w-full max-w-[200px]'>
          <Button
            loading={isLoading}
            onClick={onConfirm}
            disabled={isLoading}
            className='bg-button-primary-default text-button-primary-text w-full'
            size='lg'
          >
            כן, אחדו לי חבילות!
          </Button>
        </div>
      </div>
    </AppDialog>
  )
}
